import React, {
  useContext,
  useEffect,
  useState
} from 'react';
import {
  useParams,
} from 'react-router-dom';
import {
  Input,
  Form,
  Button,
  Modal,
  message
} from 'antd';
import axios from 'axios';
import styles from './index.module.scss';
import { useSelector } from 'react-redux';

interface OrderService {
  _id: string,
  userId: string,
  applyJobId: string,
  description: string,
  customer: {
    name: string,
    phone: string,
    address: string,
    province: string,
    district: string,
    subDistrict: string,
    postCode: string,
    lat: number,
    lng: number
  },
  images: Object[]
  orderNo: string,
  category: String,
  status: string,
  updatedAt: string,
  createdAt: string,
}

enum ORDER_SERVICE_JOP_STATUS {
  QUOTATION_DRAFT = 'QUOTATION_DRAFT',
  QUOTATION_SENT = 'QUOTATION_SENT',
}

enum ORDER_SERVICE_QUOTATION_STATUS {
  DRAFT = 'DRAFT',
  REVIEW = 'REVIEW',
}

const Quotation  = (props: any) => {
  const orderId  = props;

  const [loading, setLoading] = useState<Boolean>(true)
  const [orders, setOrders] = useState<any>({})
  let [formQuotation] = Form.useForm();
  const [visibleQuotationModal, setVisibleQuotationModal] = useState<boolean>(false);
  const [status, setStatus] = useState<String>();
  const [quotation, setquotation] = useState<any>();
  const user = useSelector((state: any) => state.user);
  

  useEffect(() => {
    if (orderId) getOrders(orderId?.orderId)
    
  }, [orderId?.orderId]);

  const getOrders = async (orderId: any) => {
    try {
      setLoading(true)
      const { data } = await axios.get(`/order-service-jobs/orderNo/${orderId}`)
      console.log('data?.data[0]', data?.data[0]);
      
      setOrders(data?.data[0])
      if (data) {
        const resposne  = await axios.get(`/order-service-quotation/${data?.data[0]?._id}`)
        console.log('resposne', resposne);
        
        setquotation(resposne);
      }
    } catch (error) {

    } finally {
      setLoading(false) 
    }
  }
  
  const createCondition = async () => {
    setVisibleQuotationModal(true);
  }

  const handleBtnCancel = () => {
    setVisibleQuotationModal(false);
  }

  const handleBtnSave = async () => {
    const quotationData = formQuotation.getFieldsValue();
    const body = {
      orderServiceJobId: orders?._id,
      jobName: quotationData.jobName,
      description: quotationData.description,
      price: quotationData.price,
      orderNo: orders?.orderNo,
      status: status,
      note: quotationData.note,
      user: user,
    };

    const dataStatus = {
      orderNo: orders?.orderNo,
      status:
        status === ORDER_SERVICE_QUOTATION_STATUS.DRAFT
          ? ORDER_SERVICE_JOP_STATUS.QUOTATION_DRAFT
          : ORDER_SERVICE_JOP_STATUS.QUOTATION_SENT,
    };

    try {
      const quotationData = await axios.post("/order-service-quotation", body);
      const { status } = quotationData;
      if (status === 200) {
        await axios.post("/order-service-jobs/status", dataStatus);
        message.success("อัพเดสรายการงานสำเร็จ");
      }
      
      setVisibleQuotationModal(false);
      // window.location.reload();
      // getOrders(data?.data.orderNo);
    } catch (error) {}
  };

  const onSetQuotation = () => {
    setStatus('REVIEW'); 
  }

  const onSetDraft = () => {
    setStatus('DRAFT'); 
  }
  
  return (
    <>
      <div className={styles.quotationMain}>
        <div className={styles.paddingBottom24}>
          <span className={styles.quotationNumber}>ใบเสนอราคา เลขที่</span>
          <span className={styles.quotationOrderNumber}>
            {" "}
            #{orders?.orderNo}
          </span>
        </div>
        <div className={styles.quotationLine}></div>
        <div className={styles.groupName}>
          <span className={styles.quotationIconCustomer}>
            <p className={styles.icon}>
              <img
                src={`/images/user-Icon.svg`}
                alt="avatar"
                style={{ textAlign: "center", marginRight: 5 }}
              />
            </p>
          </span>
          <span className={styles.quotationInfo}>ข้อมูลลูกค้า</span>
        </div>
        <div className={styles.paddingBottom20}>
          <span className={styles.quotationName}>ชื่อ - สกุลผู้ติดต่อ</span>
          <span className={styles.customerName}>{orders?.customer?.name}</span>
        </div>

        <div className={styles.paddingBottom20}>
          <span className={styles.quotationPhone}>เบอรโทรศัพท์</span>
          <span className={styles.quotationPhoneInput}>
            {orders?.customer?.phone}
          </span>
        </div>

        <div className={styles.paddingBottom20}>
          <span className={styles.quotationAddress}>ที่อยู่</span>
          <span className={styles.quotationAddressInput}>
            {/* {orders?.customer?.address} &nbsp; */}
            {orders?.customer?.province} &nbsp;
            {orders?.customer?.postCode}
          </span>
        </div>

        <div className={styles.paddingBottom20}>
          <span className={styles.quotationNote}>รายละเอียด(เพิ่มเติม)</span>
          <span className={styles.quotationNoteInput}>
            {orders?.description || "-"}
          </span>
        </div>
        <div className={styles.quotationLineDetail}></div>
        <Form id="quotationForm" form={formQuotation} onFinish={createCondition}> 
          <div className={styles.groupName}>
            <span className={styles.quotationIconDetail}>
              <p className={styles.icon}>
              <img
                src={`/images/quotation-Icon.svg`}
                alt="avatar"
                style={{ textAlign: "center", marginRight: 5 }}
              />
              </p>
            </span>
            <span className={styles.quotationInfo}>รายละเอียดใบเสนอราคา</span>
          </div>
          <div className={styles.paddingBottom20}>
            <Form.Item
              rules={[{ required: true, message: 'กรุณากรอกชื่องาน' }]}
              name={`jobName`}
              label={<label className={styles.quotationJob}>ชื่องาน</label>}
            >
              <Input
                name="jobName"
                className={styles.quotationJobInput}
              />
            </Form.Item>
            <Form.Item
            name={`description`}
              label={<label className={styles.quotationJobDetail}>รายละเอียด</label>}
            >
              <Input
                name="description"
                className={styles.quotationJobInput}
              />
            </Form.Item>
            <Form.Item
              rules={[{ required: true, message: 'กรุณากรอกราคา' }]}
              name={`price`}
              label={<label className={styles.quotationJob}>ราคาเสนอ</label>}
            >
              <Input
                name="price"
                className={styles.quotationJobInput}
              />
            </Form.Item>
          </div>
          <div className={styles.quotationLineNote}></div>
          <div className={styles.groupName}>
            <span className={styles.quotationIconNote}>
              <p className={styles.icon}>
              <img
                src={`/images/note-Icon.svg`}
                alt="avatar"
                style={{ textAlign: "center", marginRight: 5 }}
              />
              </p>
            </span>
            <span className={styles.quotationInfo}>หมายเหตุสำหรับลูกค้า</span>
          </div>
          <div className={styles.paddingBottom20}>
            <Form.Item
              name={`note`} 
              label={
                <div className={styles.note}>
                  หมายเหตุ{" "}
                  <span className={styles.quotationNoteCustomer2}>
                    (ไม่จำเป็น)
                  </span>
                </div>
              }
            >
              <Input.TextArea
                className={styles.textArea}
                placeholder="พิมพ์หมายเหตุถึงลูกค้า ไม่เกิน 1,000 ตัวอักษร"
              />
            </Form.Item>
          </div>
          {orders?.status === "ACCEPT" ||
          orders?.status === "CUSTOMER_REVISE" || orders?.status === "QUOTATION_DRAFT" ? (
            <div className={styles.flexContainer}>
              <div className={styles.flexItemLeft}>
                <Button block className={styles.btnSaveDraft} htmlType="submit" onClick={onSetDraft}> 
                  <p className={styles.textSaveDraft}>บันทึกแบบร่าง</p>
                </Button>
              </div>
              <div className={styles.flexItemRight}>
                <Button
                  block
                  className={styles.btnSaveQuotation}
                  type="primary"
                  htmlType="submit"
                  onClick={onSetQuotation}
                >
                  <p className={styles.textSaveQuotation}>ส่งใบเสนอราคา</p>
                </Button>
              </div>
            </div>
          ) : (
            ""
          )}
        </Form>
        <Modal
          // title="Basic Modal"
          visible={visibleQuotationModal}
          onCancel={handleBtnCancel}
          maskClosable={false}
          footer={[
            <Button key="Cancel" onClick={handleBtnCancel}>
              ยกเลิก
            </Button>,
            <Button
              type="primary"
              form="productForm"
              key="submit"
              htmlType="submit"
              onClick={handleBtnSave}
              // hidden={hideBtnAddProductModal}
            >
              บันทึก
            </Button>,
          ]}
        >
          <h2>ยืนยันการบันทึก</h2>
        </Modal>
      </div>
    </>
  );
}
export default Quotation;

  